import MoneyInput from 'components/MoneyInput';
import React from 'react';
import { Box } from '@mui/material';
import { useResourceContext } from 'react-admin';
import { useRateControllerContext } from '../rateController/RateControllerContext';
import { RateFieldCheckbox } from './RateFieldCheckbox';

type Props = { source: string };

export const BaseChargeRateCentsInput = ({ source }: Props) => {
  const resource = useResourceContext();
  const { isControlled } = useRateControllerContext();
  const isLocationLevel =
    resource === 'LocationPositionRateSetting' || resource === 'AgencyLocationPositionRateSetting';
  const label = isLocationLevel ? 'Base Location Rate' : 'Base 8hr Charge Rate';
  const disabled = !isControlled('baseChargeRate');

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <MoneyInput
        source={`${source}.base_charge_rate_cents`}
        label={label}
        disabled={disabled}
        sx={{ flex: 1 }}
      />
      <RateFieldCheckbox code="baseChargeRate" label="Admin controls Base Charge Rate" />
    </Box>
  );
};
